import apiClient from '@services/ApiClient';
import { exportPublicationCanvas, pngBlob } from '@services/GreetingCanvas';
import { designDimensions, layoutProblems } from '@services/GreetingGeometry';

// Both views render the same saved layout with fresh assets before uploading its snapshot.
export default async function savedGreetingPreview(orderId) {
    const { data } = await apiClient.get(`/vue/cardorders/${orderId}/greeting-design`);
    if (!data.design) throw new Error('Spara ett designutkast först.');
    const { layout } = data.design;
    const stamp = Date.now();
    const images = new Map();
    const fontIds = [...new Set(layout.objects.filter((o) => o.type === 'text').map((o) => o.font))];
    const faces = [];
    try {
        await Promise.all(fontIds.map(async (id) => {
            const font = data.fonts.find((f) => f.id === id);
            if (!font) throw new Error('Ett teckensnitt saknas.');
            const face = new FontFace(`Greeting-${id}-${stamp}`, `url(${font.url}?preview=${stamp})`);
            await face.load(); document.fonts.add(face); faces.push(face);
        }));
        await Promise.all([...new Set(layout.objects.filter((o) => o.type === 'image').map((o) => o.image_id))].map(async (id) => {
            const image = new Image();
            image.src = `/vue/greeting/images/${id}?preview=${stamp}`;
            await image.decode(); images.set(id, image);
        }));
        const size = designDimensions(layout, data.formats);
        const problems = layoutProblems(layout, size, images);
        if (problems.errors.length) throw new Error(problems.errors.join(' '));
        const renderedLayout = { ...layout, objects: layout.objects.map((o) => (o.type === 'text' ? { ...o, font: `${o.font}-${stamp}` } : o)) };
        const blob = await pngBlob(exportPublicationCanvas(renderedLayout, size, images));
        return { blob, version: data.design.version, format: layout.format };
    } finally { faces.forEach((face) => document.fonts.delete(face)); }
}
